import React, { useLayoutEffect, useRef, useState } from "react";
import { CpTooltip } from "@components";
import { Placement } from "@floating-ui/react";

type Props = {
  text: string;
  className?: string;
  position?: Placement;
};

export function TruncateText({ text, className, position }: Props) {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (!textRef.current) return;
      const { scrollWidth, clientWidth, scrollHeight, clientHeight } =
        textRef.current;
      setIsTruncated(scrollWidth > clientWidth || scrollHeight > clientHeight);
    });
    if (textRef.current) resizeObserver.observe(textRef.current);
    return () => resizeObserver.disconnect();
  }, [text]);

  if (isTruncated) {
    return (
      <CpTooltip text={text} position={position ?? "top"}>
        <div ref={textRef} className={`${className} cp-ellipsis`}>
          {text}
        </div>
      </CpTooltip>
    );
  } else {
    return (
      <div ref={textRef} className={className}>
        {text}
      </div>
    );
  }
}
